import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
 import { ToastrService } from 'ngx-toastr';
import { ErrorResponse } from 'src/app/api/model/common/error-response.model';
import { EmailContactService } from 'src/app/api/module/erp/services/email/email-contact-service';
import { BlockTemplateComponent } from 'src/app/components/block-template/block-template/block-template.component';
import { VerificaNome } from 'src/app/components/helper/form-validators/verifica-nome';

@Component({
  selector: 'app-grandes-e-pme',
  templateUrl: './grandes-e-pme.component.html',
  styleUrls: ['./grandes-e-pme.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GrandesEPmeComponent implements OnInit {
  blockTemplate: BlockTemplateComponent | undefined;

   public formNovaCotacao!: UntypedFormGroup;
   @BlockUI() public blockUI!: NgBlockUI;
  isLoading: boolean = false;
  formSubmitted: boolean = false;
  isSendEmail: boolean = true;
  heGrandeEmpresa: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
    private emailContactService: EmailContactService,
    private toastr: ToastrService,)
    { 
    
    }

  ngOnInit(): void { 
    if(this.hePME())
    {
this.heGrandeEmpresa = false
    }

    else{
      this.heGrandeEmpresa = true
    }

    this.criarForm()
  }

  criarForm(){ 
    this.formNovaCotacao = this.formBuilder.group({
      fullName: ['', Validators.required, VerificaNome, Validators.maxLength(50)],
      email: new UntypedFormControl("", [Validators.required, Validators.email]),

      telephoneNumber: ['', [ Validators.maxLength(14),Validators.required]],
      companyName: new UntypedFormControl(null, [Validators.required]),
      numberOfEmployees: new UntypedFormControl(null, [Validators.required]),
      cnpj: new UntypedFormControl(null, [Validators.required]),
      enterprise: new UntypedFormControl(null, []),
      pme: new UntypedFormControl(null, []),
      howMetGeia: new UntypedFormControl(null, [Validators.required]),
     
    });
  }
  isFormValid() {
    this.formSubmitted = true;
    return this.formNovaCotacao.invalid
  }
  onSubmit() {  
    if (this.isFormValid()) {
      return;
    } 
    this.formNovaCotacao.controls['pme'].setValue(this.hePME()); 
    try {
       this.isSendEmail = false;
      this.isLoading = true; 
        this.emailContactService.onSendLeadEnterprise(this.formNovaCotacao.value).subscribe(
          () => {
            this.toastr.success("Em breve entraremos em contato!","Sucesso");
            this.formNovaCotacao.reset();
            this.isLoading = false;
            this.formSubmitted = false;
          },

          (erro: ErrorResponse) => {
            this.toastr.error("Não foi possível enviar o E-mail.", "Aviso!");
         
            this.isLoading = false;
          }
        ); 
    }

    catch (error) {
      this.isLoading = false; 
      this.toastr.error("Não foi possível enviar o E-mail, estamos trabalhando resolver a instabilidade","Aviso");
   }

   }

   hePME(): boolean {
     
    const currentUrl = window.location.href;
    return currentUrl.includes('pme');
  }
}
